import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { LocalStorageService, SignatureRequestService, UserDocService, SignatureTypesService, WorkflowService, WorkflowMessagesService, NotificationResendService, SignerService, UserService, BovedaApi, ClientService } from "../../../services";
import { NewSignatureDetailView } from '../../views';
import { dateDayMonthCompleteAndYearComplete, getNavigatorTimezone, limitExpirationDateInContract, dateInDialogChanceDate, getStampTimeAndTimezone, LocationUtil } from '../../../utils';
import { socket } from "../../../Context";

import moment from 'moment';
import { SignatureRequestValidator } from '../../../validators';


class NewSignatureDetailAction extends Component {
  constructor(props) {
    super(props)
    this.state = {
      token: {},
      user: {},
      isLoadingView: false,
      showErrorRequesting: false,
      messageError: '',
      messageComplete: '',
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showWarningRequesting: false,
      messageWarning: "",
      signatureRequestInfo: {},
      signatureRequestId: '',
      signatureTypes: {},
      usersChat: {},
      conversation: [],
      membersChat: [],
      signers: [],
      userCanEditExpirationDate: false,
      expirationDate: '',
      visibleExpirationDate: false,
      limitExpirationDate: '',
      signStatusName: '',
      signStatusColor: '#427fba',
      isSignRequestPending: false,
      isSignRequestReject: false,
      signatureImg: null,
      ineFrontImg: null,
      ineBackImg: null,
      imgLoading: true,
      requireSignSupport: false,
      authorizerCanSign: false,
      workflowContract: {},
      completedRequest: false,
      userCanSign: "",
      visibleAccept: false,
      visibleReject: false,
      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
      errorTextArea: false,
      userRequestingSign: "",
      currentUser: {},
      isShowAutorizationModal: false,
      imgSignature: null,
      allSignatures: [],
      signRequestPDF: "",
      signatureImgeData: {},
      passwordKey: "",
      passwordReliable: "",
      selectedFileKey: null,
      selectedFileCer: null,
      tokenUserNames: "",
      tokenUserLastnames: "",
      currentUserName: "",
      dataItem: {},
      imageWidth: 450,
      pdfWidth: 170,
      showBtnNotify: true,
      idPrecharge: null,
      idVault: 0,
      visibleDialogResendSignatureRequest: false,
      userCanResendInformation: false,
      visibleDialogReactivateSignatureRequest: false,
      signRequestIsExpired: false,
      userHasPfx: false,
      userPfx: "",
      newSign: true,
      selectedFileKeyName: "",
      selectedFileCerName: "",
      signgRequestIsPackage: false,
      documentsPackage: [],
      userCanCancelSignRequest: false,
      visibleDialogDeleteRequest: false,
      commentsDelete: '',
      signRequestHasAlmostASign: false,
      documentNameToShowInSign: '',
      showCancellationReason: false,
      cancellationReason: '',
      dateLimitTypeDate: '',
      showNotifyButton: false
    }
  }

  token = {};
  user = {}
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  signatureRequestService = new SignatureRequestService(this.url);
  signatureTypesService = new SignatureTypesService(this.url);
  workflowService = new WorkflowService(this.url);
  workflowMessagesService = new WorkflowMessagesService(this.url);
  notifService = new NotificationResendService(process.env.REACT_APP_MIFIRMA_API)
  signerService = new SignerService(this.url);
  userService = new UserService(this.url);
  bovedaService = new BovedaApi(this.url);
  clientService = new ClientService(this.url)
  userDocService = new UserDocService(this.url)
  workflowExecutionId = ''
  signatureRequestId = 0
  timezone = getNavigatorTimezone()
  validator = SignatureRequestValidator(this.props.t);
  userInfo = {}
  baseSign = false


  componentDidMount() {
    this.toggleLoadingScreen(true)
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let urlArr = window.location.href.split("/");
    this.signatureRequestId = urlArr[urlArr.length - 1]
    this.userInfo =
      this.localStorageService.getLocalStorageItem("user").userMetaData;
    //call sockets
    socket.on("messages", (data) => this.addNewMessageSocket(data));
    this.getSignatureRequest()
    this.getSignatureTypes()

    this.setState({
      token: this.token,
      user: this.user,
      signatureRequestId: this.signatureRequestId
    })
  }

  async componentWillUnmount() {
    socket.emit("leaveRoom", this.workflowExecutionId)
  }

  toggleLoadingScreen = (value) => {
    this.setState({
      isLoadingView: value
    })
  }

  toggleForbiddenRequesting = () => {
    this.setState({
      showErrorRequesting: true,
      isLoadingView: false
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        this.props.history.push("/")
      }, 4000)
    })
  }

  toggleErrorRequesting = (message, time, sendInbox) => {
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          this.props.history.push("/");
        }
      }, time)
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, time, sendInbox, message) => {
    this.setState({
      showCompletedRequesting: value,
      messageComplete: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showCompletedRequesting: false,
          messageComplete: null
        })
        if (sendInbox) {
          this.props.history.push("/");
        }
      }, time)
    });
  }

  toggleWarningRequesting = (value, time, sendInbox, message) => {
    this.setState({
      showWarningRequesting: value,
      messageWarning: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showWarningRequesting: false,
          messageWarning: null
        })
        if (sendInbox) {
          this.props.history.push("/");
        }
      }, time)
    });
  }

  getSignatureRequest = async () => {
    let errorMessage = 'Ocurrió un error al consultar la solicitud de firma'
    try {
      let signatureResponse = await this.signatureRequestService.getOldSignatureRequestById(this.signatureRequestId, this.token);
      if (signatureResponse.statusCode === Number(process.env.REACT_APP_STATUS_CODE_NOT_ACCES)) {
        this.setState({ messageError: signatureResponse.message })
        this.toggleForbiddenRequesting()
        return false
      }
      let signatureRequest = signatureResponse.data
      if (!signatureRequest || !signatureRequest.userRequestingSing) {
        this.toggleLoadingScreen(false)
        this.toggleErrorRequesting(true, errorMessage, 4000, true)
        return
      }

      let userRequesting = `${signatureRequest.userRequestingSing.firstName} ${signatureRequest.userRequestingSing.firstLastName} ${signatureRequest.userRequestingSing.secondLastName}`;
      let expirationDate = dateDayMonthCompleteAndYearComplete(signatureRequest.signRequest.expirationDate)
      let limitDate60 = signatureRequest.signRequest.limitExpirationDate
      let dateStart = signatureRequest.signRequest.expirationDate;
      let limiteDate = limitExpirationDateInContract(limitDate60)
      let dateDialogChangeModal = dateInDialogChanceDate(dateStart)
      let signStatusName = signatureRequest.signRequest.signRequestStatus.name;
      let tokenUserName = `${this.user.userMetaData.userA3Cloud.firstName} ${this.user.userMetaData.userA3Cloud.firstLastName} ${this.user.userMetaData.userA3Cloud.secondLastName}`;
      let tokenUserNames = `${this.user.userMetaData.userA3Cloud.firstName}`;
      let tokenUserLastnames = `${this.user.userMetaData.userA3Cloud.firstLastName} ${this.user.userMetaData.userA3Cloud.secondLastName}`;
      let signStatusColor = '#427fba'
      let isSignRequestPending = false
      let isSignRequestReject = false
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);
      let inboxId = signatureRequest.inbox.id
      let dateLimitTypeDate = signatureRequest.signRequest.dateLimitTypeDate

      //Validate signature base
      let signatureBaseCreatedAfterWorkflow = (signatureRequest.userAutographySign && signatureRequest.userAutographySign.status) ? true : false
      let sigantureBaseIsApproved = (signatureBaseCreatedAfterWorkflow && signatureRequest.userAutographySign && signatureRequest.userAutographySign.status && signatureRequest.userAutographySign.status === process.env.REACT_APP_SIGNATURE_BASE_STATUS_APPROVED) ? true : false
      let signatureBaseCanUse = (!signatureBaseCreatedAfterWorkflow || (signatureBaseCreatedAfterWorkflow && sigantureBaseIsApproved)) ? true : false
      if (signatureRequest.autographySign && this.userInfo.userMifirma.clientId === signatureRequest.signRequest.user.clientId && signatureBaseCanUse) {
        preferences.data.map((preference) => {
          if (preference.preferenceName === process.env.REACT_APP_PREFERENCE_BASE_SIGN) {
            this.baseSign = preference.booleanValue
          }
        })
      }

      if (signatureRequest?.signRequest?.requireSignSupport) {
        try {
          let imgs = await this.userDocSuppService.getUserDocSupps(
            this.token
          );
          let { autographySignImg, ineFrontImg, ineBackImg } = imgs;
          if (autographySignImg && ineFrontImg && ineBackImg) {
            this.setState({
              signatureImg: "data:image/png;base64," + autographySignImg,
              ineFrontImg: "data:image/png;base64," + ineFrontImg,
              ineBackImg: "data:image/png;base64," + ineBackImg,
              imgLoading: false,
            });
          } else this.warningUserDontHaveIne(true);
        } catch (error) {
          this.setState({
            imgLoading: false,
          });
          this.warningUserDontHaveIne(true);
        }
      }

      if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)
      ) {
        // pending
        signStatusColor = '#FF8F00'
        isSignRequestPending = true
      } else if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)
      ) {
        // reject
        signStatusColor = '#E53935'
        isSignRequestReject = true
      } else if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET)
      ) {
        // complet
        signStatusColor = '#427fba'
      } else if (
        signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)
      ) {
        // Cancel
        signStatusColor = "#E53935"
      }

      let emailUser = `${this.user.userMetaData.userA3Cloud.email}`;
      let currentUser = signatureRequest.signersList.find((item) => item.email === emailUser);

      let showBtnNotify = (signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET)) ? false : true
      let userCanEditDate = (signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)) ? signatureRequest.userCanEditExpirationDate : false
      let showNotifyButton = false
      signatureRequest.signersList.map((signer) => {
        if ((signatureRequest.signRequest && signatureRequest.signRequest.user && signatureRequest.signRequest.user.email === signer.email) && userCanEditDate) showNotifyButton = true

        signer.notifyBtn = true
        let color = '#FF8F00'
        switch (signer.signStatusName) {
          case "Firmado":
            color = '#427fba'
            break;
          case "Rechazado":
            color = '#E53935'
            break;
          case "Cancelado":
            color = '#E53935'
            break;
          default:
            color = '#FF8F00'
        }

        signer.color = color
        return signer
      })

      let documentNameToShowInSign = ''
      let documentPathURL = signatureRequest.documentPath
      let isSignPackage = (signatureRequest.signRequest && signatureRequest.signRequest.documentManageId && signatureRequest.signRequest.documentManageId === Number(process.env.REACT_APP_SIGN_REQUEST_MANAGE_SIGN_PACKAGE_ID)) ? true : false
      let documentsPackage = []
      if (isSignPackage) {
        documentsPackage = (signatureRequest.signRequest && signatureRequest.signRequest.signDocuments && signatureRequest.signRequest.signDocuments.length > 0) ? signatureRequest.signRequest.signDocuments : []
        documentPathURL = (signatureRequest && documentsPackage.length > 0 && documentsPackage[0].documentPathURL) ? documentsPackage[0].documentPathURL : signatureRequest.documentPath
        documentNameToShowInSign = (signatureRequest && documentsPackage.length > 0 && documentsPackage[0].documentName) ? documentsPackage[0].documentName : ''
      }

      let showCancellationReason = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.signRequestStatus && signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)) ? true : false
      let cancellationReason = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.cancellationReason) ? signatureRequest.signRequest.cancellationReason : ''

      let workflowId = (isSignPackage) ? 9 : 1
      this.getWorkflowContract(workflowId)
      // this.getBovedaData(signatureRequest)
      this.setState({
        signatureRequestInfo: signatureRequest,
        signers: signatureRequest.signersList,
        userCanEditExpirationDate: userCanEditDate,
        userCanCancelSignRequest: signatureRequest.userCanCancelSignRequest && this.user.userMetaData.userMifirma.userType.id !== 3,
        signRequestHasAlmostASign: signatureRequest?.signRequest?.signRequestHasAlmostASign,
        expirationDate: expirationDate,
        limitExpirationDate: limiteDate,
        date: dateDialogChangeModal,
        requireSignSupport: signatureRequest.signRequest.requireSignSupport,
        authorizerCanSign: signatureRequest.authorizerCanSign,
        signRequestPDFURL: documentPathURL,
        userCanSign: signatureRequest.userCanSign,
        userRequestingSign: userRequesting,
        signRequestPDF: signatureRequest.documentPDF,
        userCanResendInformation: signatureRequest.userCanResendInformation,
        signRequestIsExpired: signatureRequest.signRequestIsExpired,
        signStatusName,
        signStatusColor,
        isSignRequestPending,
        isSignRequestReject,
        currentUser,
        tokenUserNames,
        tokenUserLastnames,
        currentUserName: tokenUserName,
        showBtnNotify,
        signgRequestIsPackage: isSignPackage,
        documentsPackage,
        inboxId,
        documentNameToShowInSign,
        showCancellationReason,
        cancellationReason,
        dateLimitTypeDate,
        showNotifyButton
      })
    } catch (error) {
      this.toggleLoadingScreen(false)
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
    }
  }

  getSignatureTypes = async () => {
    let errorMessage = 'Ocurrió un error al consultar los tipos de firma que existen'
    try {
      let signatureTypes = await this.signatureTypesService.getSignatureTypes(this.token);
      this.setState({
        signatureTypes
      })
    } catch (error) {
      this.toggleLoadingScreen(false)
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
    }
  }

  toggleEditExpirationDate = () => {
    this.setState({ visibleExpirationDate: !this.state.visibleExpirationDate });
  };

  onUpdateExpirationDate = async (dataItem) => {
    let messageError = 'Ocurrió un error al actualizar la fecha'
    if (!dataItem || !dataItem.expirationDate) {
      let messageErrorDate = 'Selecciona una fecha'
      this.toggleErrorRequesting(messageErrorDate, 4000, false);
      return
    }
    moment.locale("es");
    try {
      this.toggleLoadingRequesting(true);
      let { expirationDate } = dataItem;
      let { id } = this.state.signatureRequestInfo.signRequest;
      let newExpirationDate =
        await this.signatureRequestService.updateSignRequestExpirationDate(
          id,
          expirationDate,
          this.token
        );
      if (
        Number(newExpirationDate.statusCode) !== 200 ||
        !newExpirationDate.data
      ) {
        throw new Error("No se puedo actualizar la fecha de expiración");
      }

      let newDate = new Date(
        newExpirationDate.data.newExpirationDate.expirationDate
      );
      let newDateFormated = moment(newDate).format("DD/MM/YYYY");
      let updatedDate = dateDayMonthCompleteAndYearComplete(newDateFormated)
      this.setState({ expirationDate: updatedDate });

      this.toggleLoadingRequesting(false);
      this.toggleEditExpirationDate();
      this.toggleCompletedRequesting(true, 4000, false);
      return true;
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(messageError, 4000, false);
      return false;
    }
  };

  warningUserDontHaveIne = (isWarnign = false) => {
    let data = {
      message: `${this.props.t(
        "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureNotFound"
      )}`,
    };
    if (isWarnign) {
      data.isWarnign = isWarnign;
    } else data.showErrorRequesting = true;
    this.setState(data);
  };

  notifyClient = async (dataItem) => {
    this.toggleLoadingRequesting(true)
    let { signRequestId, email } = dataItem
    await this.notifService.resendNotification(signRequestId, email, this.token)
    this.toggleLoadingRequesting(false)
    this.toggleCompletedRequesting(true, 4000, false)
  }

  /**
   * @author Lucia Alvarado
   * @description Handle the submit event to reject sign
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  onSubmitReject = async (dataItem) => {
    let messageError = 'Ocurrió un error al rechazar la solicitud'
    try {
      this.clearErrors();
      this.cancel();
      // 2.- Peticion POST para rechazar solicitud de firma /signer-reject-sign
      if (dataItem.comments.trim() <= 0) {
        this.setState({ errorTextArea: true });
        return false;
      } else {
        this.setState({ errorTextArea: false, visibleReject: false });
        this.clearErrors();
        this.cancel();
        this.toggleLoadingRequesting(true);
        let signRequestId = this.state.signatureRequestInfo.signRequest.id
        let signStatusId = this.state.signatureRequestInfo.signRequest.signRequestStatus.id
        let comments = dataItem.comments
        let signReject = await this.signerService.createRejectSign(signRequestId, signStatusId, comments, this.token);
        if (signReject.statusCode === 200) {
          this.setState({ showNotification: true, showLoadingRequesting: false });
          this.toggleCompletedRequesting(true, 4000, true);
        } else if (signReject.statusCode === -1) {
          this.setState({ showNotification: true, showLoadingRequesting: false });
          this.toggleErrorRequesting(messageError, 4000, false);
          this.setState({ showNotification: true });
        }
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(messageError, 4000, false);
      return false;
    }
  };

  /**
  * @author Alan Aguilar
  * @description Method for delete the error from the state
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  clearErrors = () => {
    this.setState({
      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
      errorTextArea: false,
    });
  };

  /**
  * @author Lucia Alvarado
  * @description Show dialog reject
  * @param {Object} dataItem
  * @memberof SignatureRequestDetailAction
  */
  toggleDialogReject = () => {
    let visible = this.state.visibleReject
    this.setState({
      visibleReject: !visible,
      visibleAccept: false,
    });
  }

  /**
  * @author Lucia Alvarado
  * @description Method to clear and hide dialog
  * @memberof SignatureRequestAction
  */
  cancel = () => {
    this.setState({
      disableUserButton: true,
      errorTextArea: false,
    });
    this.clearErrors();
  };

  /**
  * @author Leonel Contreras
  * @description Close/Open the modal
  */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });

  handleWarning = () => this.setState({ isWarnign: !this.state.isWarnign });

  setPassword = (passwordKey) => this.setState({ passwordKey });
  setIsShowAutorizationModal = () =>
    this.setState({
      isShowAutorizationModal: !this.state.isShowAutorizationModal,
    });


  /**
  * @author Lucia Alvarado
  * @description Handle the submit event to accept sign
  * @updatedDate 01-04-2022
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  onSubmit = async (nip, setNip, stampTime, bufferVideo, bufferImage) => {
    try {
      this.toggleLoadingRequesting(true);
      this.clearErrors();
      this.setState({ visibleAccept: false });

      if (this.state.userCanSign === false) return false;
      if (this.state.errorFileKey === true || this.state.errorFileCer === true)
        return false;

      if (this.baseSign && this.state.allSignatures.find((i) => !!i.fileSignImage)) {
        let newNip = await this.userDocService.verifyNip(nip, this.token)
        if (newNip.isEqual === false) {
          setNip("")
          this.setState({
            message: this.props.t(`signatureRequestDetailAction2.errorNip`),
          });
          this.toggleLoadingRequesting(false);
          this.toggleErrorRequesting(this.props.t(`signatureRequestDetailAction2.errorNip`), 3000);
          return false
        }
      }

      // Capture the user's IP address and geolocation when signing
      const { ip, latitude, longitude } = await LocationUtil.getIPAndLocation()
      const userGeolocationAuthorization = latitude !== null && longitude !== null

      // 1.- Peticion POST para aceptar la solicitud de firma /signer-confirm-sign
      let signRequestDocumentData = new FormData();
      signRequestDocumentData.append(
        "signRequestId",
        this.state.signatureRequestInfo.signRequest.id
      );
      signRequestDocumentData.append(
        "signatureTypeId",
        this.state.signatureRequestInfo.signRequest.signatureTypeId
      );
      signRequestDocumentData.append("signatureStampTime", stampTime);

      // Add IP address, geolocation, and authorization to the FormData
      if (userGeolocationAuthorization && latitude !== null && longitude !== null) {
        if (ip) signRequestDocumentData.append('ip', ip)
        signRequestDocumentData.append('userGeolocationAuthorization', true)
        const geoLocation = { latitude, longitude }
        signRequestDocumentData.append('geolocation', JSON.stringify(geoLocation))
      }

      if (this.state.currentUser.proofOfLife) {
        signRequestDocumentData.append("bufferVideo", bufferVideo)
        signRequestDocumentData.append("bufferImage", bufferImage)
      }

      if (!!this.state.allSignatures.find((i) => !!i.fileSignImage)) {
        signRequestDocumentData.append(
          "signatures",
          JSON.stringify(
            this.state.allSignatures.map((i) => ({
              x: i.x,
              y: i.heightImg - i.y - 100,
              width: i.width,
              height: i.height,
              page: i.page,
              isMobile: !!i.isMobile,
              fileName: i.fileName,
            }))
          )
        );
        this.state.allSignatures.forEach((i) => {
          signRequestDocumentData.append(i.fileName, i.fileSignImage);
        });
      }
      else {
        if (this.state.passwordKey)
          signRequestDocumentData.append("passwordKey", this.state.passwordKey);
        if (this.state.passwordReliable)
          signRequestDocumentData.append(
            "passwordReliable",
            this.state.passwordReliable
          );

        signRequestDocumentData.append("fileKEY", this.state.selectedFileKey);
        signRequestDocumentData.append("fileCER", this.state.selectedFileCer);
      }

      let updateSignData = {
        inboxId: this.state.inboxId,
        showInbox: false
      }

      const signDocumentPackage = await this.signerService.signDocumentPackage(
        signRequestDocumentData,
        this.token
      )

      if (signDocumentPackage.statusCode === 420 && (signDocumentPackage.data && signDocumentPackage.data.signing)) {
        this.toggleLoadingRequesting(false);
        this.setState({ showNotification: true });
        this.toggleWarningRequesting(true, 6000, false, `${this.props.t(
          "signRequestDetail.isSigningPt1"
        )} ${signDocumentPackage.data.emailSigner} ${this.props.t(
          "signRequestDetail.isSigningPt2"
        )}`);
        return
      } else if (signDocumentPackage.statusCode === 200) {
        let showSign = await this.signerService.updateShowSign(updateSignData, this.token)
        this.toggleLoadingRequesting(false);
        this.setState({ showNotification: true });
        this.toggleCompletedRequesting(true, 6000, true, 'Tu firma está en proceso, por lo que una vez que concluya, se te hará llegar un correo informándote el resultado.');
      } else if (signDocumentPackage.statusCode === 450 || signDocumentPackage.statusCode === 452) {
        let messageError = `${this.props.t(
          "signatureRequestDetailAction2.errors.facerecognititon.face.no.match"
        )}`
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(messageError, 4000, true);
        return false;
      } else if (signDocumentPackage.statusCode === 490) {
        let messageError = `${this.props.t(
          "signatureRequestDetailAction2.errors.facerecognititon.canceled"
        )}`
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(messageError, 4000, true);
        return false;
      } else {
        let messageError = `${this.props.t(
          "signatureRequestDetailAction2.errors.general"
        )}`
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(messageError, 4000, false);
        return false;
      }

      // if (signConfirm.statusCode === 200) {
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleCompletedRequesting(true, 4000, true);
      // } else if (signConfirm.statusCode === 420) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorValidateInformationProvided")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === 403) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorUserDoesNotHaveAccess")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -2) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorUserCreateSignRequestDontHaveCredits")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -3) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorSequentialSignerNotTurnOrAlreadySign")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -4) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorWithAprovationPendingAuthorizers")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -5) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorWithAprovationSequentialPendingAuthorizers")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -6) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorWithAprovationSequentialNotTurn")}`
      //   this.toggleLoadingRequesting(false);
      //   this.toggleErrorRequesting(messageError, 4000, false);
      //   this.setState({ showNotification: true });
      // } else if (signConfirm.statusCode === -11) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorCertificateESignatureIsExpired")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -12) {
      //   let messageError = `${this.props.t("signatureRequestDetailAction2.errorCertificateRFCNotValid")}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -13) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorSATServiceNotAvailable"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -14) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorCertificateSATServiceResponse"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -15) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorValidationFilesESignature"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -15) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorValidationFilesESignature"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -16) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorRFCOfUserNotFoundOrInvalid"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -22) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorCertificateAdvanceSignatureIsExpired"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -23) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorValidationFilesAdvanceSignature"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -30) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorOnServicesPSC"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -31) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureNotFound"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else if (signConfirm.statusCode === -32) {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureExpired"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // } else {
      //   let messageError = `${this.props.t(
      //     "signatureRequestDetailAction2.errorSignatureReliable"
      //   )}`
      //   this.toggleLoadingRequesting(false);
      //   this.setState({ showNotification: true });
      //   this.toggleErrorRequesting(messageError, 4000, false);
      // }
    } catch (error) {
      let messageError = `${this.props.t(
        "signatureRequestDetailAction2.errorDefaultSignerConfirm"
      )}`
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(messageError, 4000, false);
      return false;
    }
  };

  /**
  * @author Lucia Alvarado
  * @description Show dialog confirm
  * @param {Object} dataItem
  * @memberof SignatureRequestDetailAction
  */
  toggleDialogAccept = () => {
    this.setState({
      visibleAccept: !this.state.visibleAccept,
      visibleReject: false,
    });
  }


  /**
  * @author Alan Aguilar
  * @description Method Delete the ConfirmationSign dato from the state
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  onDeleteDataAccept = () => {
    this.setState({
      visibleAccept: false,
      dataItem: {},
      selectedFileKey: null,
      selectedFileCer: null,
    });
    this.clearErrors();
  }


  // getBovedaData = async (signatureRequest) => {
  //   let messageError = 'Ocurrió un error al consultar la información desde el módulo de Bóveda'
  //   let emailUser = `${this.user.userMetaData.userA3Cloud.email}`;
  //   let responseUploaded;

  //   try {
  //     const canUploadDocument = await this.userService.getRolesForUserByEmail(this.token, emailUser);
  //     if (canUploadDocument.data.roleBoveda && canUploadDocument.data.roleBoveda.key && canUploadDocument.data.roleBoveda.key !== "roleHibouDigitalVaultNotAccess") {
  //       responseUploaded = await this.bovedaService.getBovedaDocument(signatureRequest.signRequest.id, this.token);
  //       this.setState({
  //         idVault: canUploadDocument.data.roleBoveda.id
  //       });
  //     } else {
  //       this.toggleLoadingScreen(false)
  //       return
  //     }

  //     if (
  //       responseUploaded &&
  //       responseUploaded.idPrecarga &&
  //       (canUploadDocument.data.roleBoveda.id === 14 ||
  //         canUploadDocument.data.roleBoveda.id === 15)
  //     ) {
  //       this.setState({
  //         idPrecharge: responseUploaded.idPrecarga,
  //         idVault: canUploadDocument.data.roleBoveda?.id,
  //       });
  //     } else if (responseUploaded && responseUploaded.code === -3) {
  //       this.setState({
  //         idPrecharge: undefined,
  //       });
  //     }
  //     this.toggleLoadingScreen(false)
  //   } catch (error) {
  //     this.toggleLoadingScreen(false)
  //     this.toggleErrorRequesting(true, messageError, 4000, true)
  //   }
  // }

  // sendToDigitalVault = async (signRequestId) => {
  //   this.toggleLoadingRequesting(true)
  //   let messageError = 'Ocurrió un error al enviar el documento a Bóveda'
  //   try {
  //     let response = await this.bovedaService.uploadBovedaDocument(signRequestId, this.token
  //     );
  //     if (response && response.code === 200) {
  //       this.setState({
  //         idPrecharge: response.idPrecarga,
  //       });
  //       this.toggleLoadingRequesting(false)
  //       this.toggleCompletedRequesting(true, 4000, true)
  //     } else {
  //       this.toggleLoadingRequesting(false);
  //       this.toggleErrorRequesting(messageError, 4000, false);
  //     }
  //   } catch (error) {
  //     this.toggleLoadingRequesting(false);
  //     this.toggleErrorRequesting(messageError, 4000, false);
  //   }
  // };

  /**
  * @author Alan Aguilar
  * @description Method to show the resend signature request dialog
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  toggleDialogResendSignatureRequest = () => {
    this.setState({
      visibleDialogResendSignatureRequest:
        !this.state.visibleDialogResendSignatureRequest,
    });
  };

  /**
  * @author Alan Aguilar
  * @description Call service to resend the information of the sign request completed
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  onResendSignatureRequest = async () => {
    let messageError = 'Ocurrió un error al reenviar la información'
    try {
      this.toggleLoadingRequesting(true);
      let result =
        await this.signatureRequestService.resendSignRequestInformation(
          this.state.signatureRequestInfo.signRequest.id,
          this.token
        );
      if (result && result.statusCode === 200) {
        this.toggleLoadingRequesting(false);
        this.setState({ visibleDialogResendSignatureRequest: false });
        this.toggleCompletedRequesting(true, 4000, false);
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(messageError, 4000, false);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(messageError, 4000, false);
    }
  };


  /**
  * @author Alan Aguilar
  * @description Method to show the reactivation signature request dialog
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  toggleDialogReactivateSignatureRequest = () => {
    this.setState({
      visibleDialogReactivateSignatureRequest:
        !this.state.visibleDialogReactivateSignatureRequest,
    });
  };


  /**
  * @author Alan Aguilar
  * @description Call service to reactivate a the sign request when rejected
  * @updatedDate 03-06-2021
  * @memberof SignatureRequestAction
  */
  onReactivateSignatureRequest = async () => {
    let messageError = 'Ocurrió un error al reactivar la solicitud de firma'
    try {
      this.toggleLoadingRequesting(true);
      let result = await this.signatureRequestService.reactivationSignRequestRejected(this.state.signatureRequestInfo.signRequest.id, this.token);
      if (result && result.statusCode === 200) {
        this.toggleLoadingRequesting(false);
        this.setState({ visibleDialogReactivateSignatureRequest: false });
        this.toggleCompletedRequesting(true, 4000, true);
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(messageError, 4000, false);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(messageError, 4000, false);
    }
  };

  /**
  * @author Alan Aguilar
  * @description Method to get the file
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  handleFileCer = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];

      if (extension === "cer" || extension === "pem") {
        this.setState({
          selectedFileCer: e.target.files[0],
          errorFileCer: false,
          selectedFileCerName: filename,
        });
      } else {
        this.setState({
          selectedFileCer: null,
          errorFileCer: true,
          selectedFileCerName: `${this.props.t(
            "signatureRequestDetailAction2.noUploadFile"
          )}`,
        });
        return false;
      }
    } else {
      return false;
    }
  };

  /**
  * @author Alan Aguilar
  * @description Handler method for capture the information in all inputs
  * @date 15-12-2020
  * @param {Object} e
  * @memberof AuthService
  */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /**
  * @author Alan Aguilar
  * @description Method to get the file
  * @param {Event} event
  * @memberof SignatureRequestDetailAction
  */
  handleFileKey = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];

      if (extension === "key" || extension === "pem") {
        this.setState({
          selectedFileKey: e.target.files[0],
          errorFileKey: false,
          selectedFileKeyName: filename,
        });
      } else {
        this.setState({
          selectedFileKey: null,
          errorFileKey: true,
          selectedFileKeyName: `${this.props.t(
            "signatureRequestDetailAction2.noUploadFile"
          )}`,
        });
        return false;
      }
    } else {
      return false;
    }
  };

  getWorkflowContract = async (workflowId) => {
    let errorMessage = 'Ocurrió un error al consultar la información dedl workflow'
    let solicitudeId = this.signatureRequestId

    try {
      let workflow = await this.workflowService.getWorkflowBySolicitudeIdAndWorkflowId(solicitudeId, workflowId, this.token)
      if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
        this.workflowExecutionId = workflow.data.id
        socket.emit("joinRoom", this.workflowExecutionId)
        this.getMessages(workflow.data)
        this.toggleLoadingScreen(false)
        this.setState({
          workflowContract: workflow.data
        })
      } else {
        this.toggleErrorRequesting(true, errorMessage, 4000, true)
        this.toggleLoadingScreen(false)
      }
    } catch (error) {
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
      this.toggleLoadingScreen(false)
    }
  }

  getMessages = async (workflow) => {
    let errorMessage = "Ocurrió un error al consultar los mensajes";
    let workflowExecutionId = workflow.id
    let user = {};
    try {
      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          workflowExecutionId,
          this.timezone,
          this.token
        );
      if (
        workflowMessage &&
        workflowMessage.data &&
        Number(workflowMessage.statusCode) === 200
      ) {
        //Filter out duplicated members
        let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
          workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
        );
        //users chat
        membersChat.map((member) => {
          member.id = member.workflowExecutionMemberId;
          member.avatarUrl = member.profilePicture;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarAltText = member.firstName + " " + member.firstLastName;
          if (this.user.userMetaData.userA3Cloud.email === member.email) {
            this.idAuthorMessage = member.id;
            user = member;
          }
          return membersChat;
        });

        //Message chat
        workflowMessage.data.workflowExecutionMessages.map((member) => {
          member.author = {
            name: member.firstName + " " + member.firstLastName,
            id: member.workflowExecutionMemberId,
            avatarUrl: member.profilePicture,
          };
          let dateConvert = new Date(member.createdDate)
          member.timestamp = dateConvert
          member.text = member.workflowExecutionMemberMessage;
          member.id = member.workflowExecutionMemberId;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarUrl = member.profilePicture;
          if (member.workflowExecutionMemberMessageDoc.length > 0) {
            member.attachments = [
              {
                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
              },
            ];
          }
          return workflowMessage.data.workflowExecutionMessages;
        });
        this.setState({
          membersChat: membersChat,
          conversation: workflowMessage.data.workflowExecutionMessages,
          usersChat: user,
        });
        this.toggleLoadingRequesting(false);
      } else {
        this.toggleLoadingScreen(false)
        this.toggleErrorRequesting(true, errorMessage, 4000, true)
      }
    } catch (error) {
      this.toggleLoadingScreen(false)
      this.toggleErrorRequesting(true, errorMessage, 4000, true)
    }
  };

  //Function to create message
  createMessage = async (messagesChat, fileContent) => {
    let data = new FormData();
    data.append("workflowExecutionId", this.workflowExecutionId);
    data.append("workflowExecutionMemberId", this.idAuthorMessage);
    data.append("message", messagesChat.text);
    data.append("documento", fileContent);
    data.append("timezone", this.timezone)

    if (messagesChat.usersMentioned && messagesChat.usersMentioned.length > 0) {
      data.append('usersMentioned', JSON.stringify(messagesChat.usersMentioned))
    }

    await this.workflowMessagesService.createWorkflowExecutionNewMessage(
      data,
      this.token
    );
  };

  markChatAsRead = async () => {
    try {
      await this.workflowMessagesService.markAsRead(this.workflowExecutionId, this.token)
    } catch (e) { }
  };

  //add a new meessage to conversation when sockets send a mew message
  addNewMessageSocket = (message) => {
    let copyConversation = [...this.state.conversation];
    let indexMessage = copyConversation.length;

    let newMessage = {
      author: {
        name: `${message.firstName} ${message.firstLastName}`,
        id: Number(message.workflowExecutionMemberId),
        avatarUrl: message.profilePicture,
      },
      timestamp: message.workflowExcecutionMemberMessage
        ? new Date(message.workflowExcecutionMemberMessage.createdDate)
        : new Date(
          message.workflowExecutionMemberMessageDocName[0].createdDate
        ),
      text: message.workflowExcecutionMemberMessage.message,
      id: Number(message.workflowExecutionMemberId),
      name: `${message.firstName} ${message.firstLastName}`,
      avatarUrl: message.profilePicture,
      workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
      workflowExecutionMemberMessage:
        message.workflowExcecutionMemberMessage.message === "" ||
          message.workflowExcecutionMemberMessage.message === "undefined"
          ? null
          : message.workflowExcecutionMemberMessage.message,

      email: message.email,
      firstName: message.firstName,
      firstLastName: message.firstLastName,
      profilePicture: message.profilePicture,
      selectionIndex: indexMessage,
    };
    if (message.workflowExecutionMemberMessageDocName.length > 0) {
      newMessage.workflowExecutionMemberMessageDoc = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
      newMessage.attachments = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
    }

    copyConversation.push(newMessage);
    this.setState({
      conversation: copyConversation,
    });
  };

  toggleDialogDeleteRequest = () => {
    this.setState({
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
    });
  };

  handleCommentsDelete = async (event) => {
    this.setState({
      commentsDelete: event.target.value,
    });
  };

  deleteSignRequest = async () => {
    let commentsDelete = this.state.commentsDelete;
    let signRequest = this.state.signatureRequestInfo.signRequest;
    let statusCode = 0;

    try {
      await this.toggleLoadingRequesting(true);
      let signRequestDetele =
        await this.signatureRequestService.deleteSignRequestsById(
          signRequest.id,
          commentsDelete,
          this.token
        );
      if (signRequestDetele.statusCode !== 200) {
        statusCode = signRequestDetele.statusCode;
        throw new Error();
      }

      this.setState({ visibleDialogDeleteRequest: false });
      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true, true);
      return true;
    } catch (error) {
      let message = ''
      switch (statusCode) {
        case -2:
          message = this.props.t(
            "signatureRequestDetailAction2.errorMessageOnlyUserSenderCanDelete"
          );
          break;
        case -3:
          message = this.props.t(
            "signatureRequestDetailAction2.errorMessageOnlyDeleteWithAlmostOneSign"
          )
          break;
        default:
          message = this.props.t(
            "signatureRequestDetailAction2.errorMessageDefault"
          )
          break;
      }
      this.setState({ visibleDialogDeleteRequest: false });
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(message, 4000, false);
      return false;
    }
  };

  scrollWindow = () => {
    window.scrollTo(0, 0)
  }

  validateNip = async (nip, setNip) => {
    let validatedNip
    if (this.baseSign && !this.state.currentUser.proofOfLife) {
      try {
        let nipValidated = await this.userDocService.verifyNip(nip, this.token)
        if (nipValidated.isEqual === false) {
          validatedNip = nipValidated.isEqual
          setNip("")
          await this.toggleLoadingRequesting(false);
          await this.toggleErrorRequesting(this.props.t(`signatureRequestDetailAction2.errorNip`), 4000, false);
        } else {
          validatedNip = true
        }
      } catch (e) {
        setNip("")
        validatedNip = false
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(this.props.t(`signatureRequestDetailAction2.errorNip`), 4000, false);
      }
    }
    return validatedNip
  }

  render() {
    if ((this.state.currentUser && this.state.currentUser.proofOfLife) || (this.state.currentUser && !this.state.currentUser.signatureBaseValid)) this.baseSign = false
    return (
      <NewSignatureDetailView
        {...this.state}
        baseSign={this.baseSign}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
        toggleLoadingScreen={this.toggleLoadingScreen}
        createMessage={this.createMessage}
        markChatAsRead={this.markChatAsRead}
        toggleEditExpirationDate={this.toggleEditExpirationDate}
        validator={this.validator}
        onUpdateExpirationDate={this.onUpdateExpirationDate}
        notifyClient={this.notifyClient}
        toggleDialogReject={this.toggleDialogReject}
        onSubmitReject={this.onSubmitReject}
        setIsShowAutorizationModal={this.setIsShowAutorizationModal}
        setImgSignature={(params) => this.setState(params)}
        setSignatures={(signatures) => this.setState({ allSignatures: signatures })}
        onSubmit={this.onSubmit}
        toggleDialogAccept={this.toggleDialogAccept}
        onDeleteDataAccept={this.onDeleteDataAccept}
        setSignatureImgeData={(signatureImgeData) => { this.setState({ signatureImgeData }, () => this.onSubmit()) }}
        // sendToDigitalVault={this.sendToDigitalVault}
        toggleDialogResendSignatureRequest={this.toggleDialogResendSignatureRequest}
        onResendSignatureRequest={this.onResendSignatureRequest}
        toggleDialogReactivateSignatureRequest={this.toggleDialogReactivateSignatureRequest}
        onReactivateSignatureRequest={this.onReactivateSignatureRequest}
        handleFileCer={this.handleFileCer}
        onHandleGeneralChange={this.onHandleGeneralChange}
        handleFileKey={this.handleFileKey}
        setPassword={this.setPassword}
        toggleDialogDeleteRequest={this.toggleDialogDeleteRequest}
        deleteSignRequest={this.deleteSignRequest}
        handleCommentsDelete={this.handleCommentsDelete}
        scrollWindow={this.scrollWindow}
        validateNip={this.validateNip}
      />
    )
  }
}

export default withTranslation()(NewSignatureDetailAction);
